// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__369-p","errorLogs":"EditorFooter_errorLogs__rXDJb"};